export default "__VITE_ASSET__Diriu39b__"